import React, { useState } from 'react';

async function clearCacheAndReload() {
  // Unregister all service workers
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map(r => r.unregister()));
  }
  // Clear all caches
  if ('caches' in window) {
    const keys = await caches.keys();
    await Promise.all(keys.map(k => caches.delete(k)));
  }
  // Hard reload bypassing cache
  window.location.reload(true);
}
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await axios.post(`${API_URL}/api/auth/login`, { username, password });
      localStorage.setItem('token', res.data.token);
      localStorage.setItem('user', JSON.stringify(res.data.user));
      window.location.href = '/dashboard';
    } catch (err) {
      setError(err.response?.data?.detail || 'Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: '#1a2744' }}>
      <div className="w-full max-w-md px-4">
        <div className="flex flex-col items-center mb-8">
          <div className="w-16 h-16 rounded-2xl flex items-center justify-center mb-4" style={{ backgroundColor: '#2a4a7f' }}>
            <svg className="w-10 h-10 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9 12h6M9 16h6M13 4H6a2 2 0 00-2 2v14a2 2 0 002 2h12a2 2 0 002-2V9l-5-5z" />
              <path d="M13 4v5h5" />
            </svg>
          </div>
          <h1 className="text-2xl font-bold text-white">Discovery Records</h1>
          <p className="text-blue-300 mt-1">Records Management System</p>
        </div>

        <div className="bg-white rounded-lg shadow-xl p-8">
          <h2 className="text-xl font-semibold text-gray-800 mb-6">Sign in to your account</h2>

          {error && (
            <div className="mb-4 p-3 bg-red-50 border border-red-200 text-red-700 rounded-md text-sm">
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Username</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter your username"
                required
              />
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Password</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                placeholder="Enter your password"
                required
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              className="w-full py-2.5 px-4 rounded-md text-white font-medium transition-colors disabled:opacity-60"
              style={{ backgroundColor: '#1a2744' }}
              onMouseOver={(e) => !loading && (e.target.style.backgroundColor = '#243556')}
              onMouseOut={(e) => !loading && (e.target.style.backgroundColor = '#1a2744')}
            >
              {loading ? 'Signing in...' : 'Sign In'}
            </button>
          </form>

          <div className="mt-4 text-center">
            <button
              type="button"
              onClick={clearCacheAndReload}
              className="text-xs text-gray-400 hover:text-blue-600 underline transition-colors"
            >
              🔄 Clear cache &amp; reload (get latest version)
            </button>
          </div>

          <div className="mt-4 pt-4 border-t border-gray-200">
            <p className="text-sm font-medium text-gray-500 mb-3">Demo Accounts</p>
            <div className="space-y-2 text-sm text-gray-600">
              <div className="flex justify-between items-center bg-gray-50 rounded px-3 py-2">
                <span className="font-medium">Employee:</span>
                <span className="font-mono text-xs">employee1 / emp123</span>
              </div>
              <div className="flex justify-between items-center bg-gray-50 rounded px-3 py-2">
                <span className="font-medium">Admin:</span>
                <span className="font-mono text-xs">adminlegal / admin123</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
